export default {
    name: 'index',
    data() {
        return {
            code:'', 
            loading: false,
            reportslist:[],
            mapinfo:{code:'',mapcode:''},
            isShowMapCode:false,
            isShowReports:false
        };
    },
    methods: {
        // 用于初始化一些数据
        init() {
            this.SearchStockTotalInfo();//
  
        },
        // 用于更新一些数据
          
       async SearchStockTotalInfo(){
           
        this.loading = true;
        var that=this

        let arrCode=[]
        if(this.code!='' && this.code!=undefined){
            let codeitem=this.code
            if(codeitem.indexOf(' ')){
                let codesplit=codeitem.split(' ') 
                codesplit.forEach(function (v) {
                    if(v!=' '){
                        arrCode.push(v)
                    }
                })
            }
            else
            {
                arrCode.push(this.code)
            }
        }
            const res = await this.$http.post('StockAlignMap/SearchStockTotalInfo', {code:arrCode});//id=1 
            if(res.Status){ 
                this.reportslist=res.Result; 
                this.reportslist.forEach(function (v) {  
                    if(v.shouru.bennian!=null && v.shouru.bennian!="NA"){

                        v.shouru.bennian=that.Bigmoney(v.shouru.bennian)
                    }
                    if(v.shouru.shangnian!=null && v.shouru.shangnian!="NA"){
                        
                    v.shouru.shangnian=that.Bigmoney(v.shouru.shangnian)
                    }
                    if(v.shouru.xianian!=null && v.shouru.xianian!="NA"){
                        
                    v.shouru.xianian=that.Bigmoney(v.shouru.xianian)
                    }
                })



            }
            this.loading = false;
    
           },  
           Bigmoney(value){
               var param = {};
               var k = 10000,
                   sizes = ['', '万', '亿', '万亿'],
                   i;
               if (value < k) {
                   param.value = value
                   param.unit = ''
               } else {
                   i = Math.floor(Math.log(value) / Math.log(k));
           
                   param.value = ((value / Math.pow(k, i))).toFixed(2);
                   param.unit = sizes[i];
               }
               return param.value+param.unit;
           } 

    },
    // 计算属性
    computed: {
        identity() {
            let identity = '管理员';
            return identity;
        }
    },
    // 包含 Vue 实例可用过滤器的哈希表。
    filters: {},
    // 在实例创建完成后被立即调用
    created() { },
    // 在挂载开始之前被调用：相关的 render 函数首次被调用。
    beforeMount() {
         
    },
    // el 被新创建的 vm.el 替换，并挂载到实例上去之后调用该钩子。
    mounted() {
        this.$nextTick(() => { 
            this.init();
        });
    },
    // 数据更新时调用，发生在虚拟 DOM 打补丁之前。
    beforeUpdate() { },
    // keep-alive 组件激活时调用。
    activated() { },
    // keep-alive 组件停用时调用。
    deactivated() { },
    // 实例销毁之前调用。在这一步，实例仍然完全可用。
    beforeDestroy() { },
    //Vue 实例销毁后调用。
    destroyed() { },
    // 当捕获一个来自子孙组件的错误时被调用。
    errorCaptured() { },
    // 包含 Vue 实例可用指令的哈希表。
    directives: {},
    // 一个对象，键是需要观察的表达式，值是对应回调函数。
    watch: {},
    // 组件列表
    components: {},
};